import { render, staticRenderFns } from "./QueueManage.vue?vue&type=template&id=05109282"
import script from "./QueueManage.vue?vue&type=script&lang=js"
export * from "./QueueManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports